<template>
  <div>
    <div v-if="item.quantity === 0" class="product__prices not-available">
      <div class="product__price" style="width: 100%;">Нет в наличии</div>
      <div class="product__buy-action">
        <div @click="addWaitingList(item, +item.step)" class="product__btn send-button form-data__button button button_theme_primary_blue button_size_sm">
          <span class="btn__text">В лист ожидания</span>
        </div>
      </div>
    </div>
    <div v-if="item.quantity > 0 || item.storage.transit !== 0" class="product__product-summary-controls product-summary-controls product-summary-controls_catalog">
      <div class="product-summary-controls__select select select_theme_toggle">
        <div class="select__caption">
          Заказать в
        </div>
        <span></span>
        <select
                v-model="item.step"
                name="VARIANT_QUANTITY"
                class="select__input"
        >
          <!--<option
                  v-for="pack in item.packing"
                  :key="pack.id"
                  :selected="pack.value == item.step"
                  :value="pack.value"
          >
            {{ pack.label }} ({{ pack.value }} шт.)
          </option>-->

          <option
                  v-for="(packing, index) in item.packing"
                  :key="index"
                  :selected="packing.ratio == item.step"
                  :value="packing.ratio"
          >
            {{ packing.text }} ({{ packing.ratio }} шт.)
          </option>

        </select>
      </div>
      <div class="product-summary-controls__quantity quantity quantity_size_lg quantity_btn-buy">
        <button
                @click="updateQuantity(item, -item.step)"
                class="quantity__button quantity__button_minus">
          <span class="quantity__button-icon icon icon-minus"></span>
        </button>
        <input type="text"
               name="QUANTITY_INPUT"
               class="quantity__input" placeholder="0"
               @blur="updateQuantityInp(item, $event.target.value)"
               @keypress.enter.prevent
               @click="inputFocus"
               ref="inputCount"
               :value="basketCount"
        >
        <button
                @click="updateQuantity(item, +item.step)"
                class="quantity__button quantity__button_plus">
          <span class="quantity__button-icon icon icon-plus"></span>
        </button>
      </div>

      <div v-if="item.history"
           class="product__report-link tooltip tooltip_type_data tooltip_order_history"
           data-tooltipposition="top" data-tooltipsize="large"
           data-product-id="item.id">
        <div class="tooltip__title">
          <vue-popper :id="item.id + '-el-history'" :placement="'left'">
            <template v-slot:tooltip>
              <table class="table-tooltip">
                <tr>
                  <th>№ заказа</th>
                  <th>Дата</th>
                  <th>Заказано</th>
                  <th>Отгружено</th>
                </tr>
                <tr v-for="order in item.history.items">
                  <th>{{ order.id }}</th>
                  <th>{{ order.date }}</th>
                  <th>{{ order.quantity_plan }}</th>
                  <th>{{ order.quantity }}</th>
                </tr>
              </table>
            </template>
            Заказывали {{ item.history.items[0].quantity_plan }} шт. {{ item.history.items[0].date }}
          </vue-popper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import eventBus from "./EventBus.vue";
  import VuePopper from "./VuePopper.vue";

  export default {
    name: "ProductSummaryControls",
    props: ['item', 'productId', 'v', 'x', 'cartCount'],
    data: function () {
      return {
        //basket: this.$ls.get('basket'),
        basket: [],
        notifyIds: [],
        basketCount:0,
        groupNotify: 'custom-template'
      }
    },
    computed: {
      user() {
        let result;
        if ('user' in this.$store.getters.page)
          result = this.$store.getters.page.user;
        else
          result = {};
        return result;
      },
    },
    mounted() {
      this.basketCount = this.cartCount;
      this.$ls.on('basket', this.changeBasket);
      document.addEventListener("updateBasket", this.changeBasket);
    },
    filters: {
      formatQuantity: function (value) {
        return value;
      },
    },
    methods: {

      inputFocus: function(){
        let input = this.$refs.inputCount;
        input.focus();
        input.select();
      },

      updateQuantity: function (item, quantity) {
        if (quantity === undefined) {
          quantity = 1;
        } else {
          quantity = Number(quantity);
        }

        let vm = this;

        //TODO: После утвержения удалить droptransit
        if (item.storage.first == 0 && item.storage.second == 0 && false) {
          axios.post(
                  '/api/transit/add',
                  {
                    'productId': item.id,
                    'quantity': quantity,
                  },
                  {
                    headers: {
                      'content-type': 'application/json; charset=utf8',
                      'X-Requested-With': 'XMLHttpRequest',
                    }
                  }
          )
                  .then(function (response) {
                    if (response.status == 200) {
                      item.transit_list = quantity;
                      vm.drawNotify(item, response.data);

                      return false;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });

          return false;
        } else {
          axios.post(
                  '/api/cart/add/' + vm.productId,
                  {
                    'quantity': quantity,
                  },
                  {
                    headers: {
                      'content-type': 'application/json; charset=utf8',
                      'X-Requested-With': 'XMLHttpRequest',
                    }
                  }
          )
                  .then(function (response) {
                    if (response.status == 200) {
                      let data = response.data;
                      let basket = vm.$ls.get('basket');

                      if (data.status) {
                        let result = data.result;
                        switch(data.type) {
                          case 'add':
                            let product = result.product;
                            basket.count += product.quantity;
                            basket.volume += product.dimensions.volume * result.quantity / product.packing.torg.value;
                            basket.weight += product.dimensions.weight;
                            basket.price = result.price;

                            basket.items.push(product);

                            break;
                          case 'change':
                            basket.items.forEach(function (item, index) {
                              if (item.id == result.id) {
                                basket.count += result.quantity;
                                basket.volume += item.dimensions.volume * result.quantity / item.packing.torg.value;
                                basket.weight += item.dimensions.weight;

                                item.quantity += result.quantity;
                              }
                            })
                            basket.price = result.price;
                            break;
                          case 'delete':
                            basket.items.forEach(function (item, index) {
                              if (item.id == result.id) {
                                basket.count -= item.quantity;
                                basket.volume -= item.dimensions.volume;
                                basket.weight -= item.dimensions.weight;

                                basket.items.splice(index, 1);
                              }
                            });
                            basket.price = result.price;
                            vm.basketCount = 0;
                            break;
                          default:
                            console.log('Ошибка при добавлении товара! Тип');
                        }
                      } else {
                        console.log('Ошибка при добавлении товара! Статус');
                      }

                      vm.$ls.set('basket', basket);
                      document.dispatchEvent(new CustomEvent("updateBasket", {detail: basket}));

                      if (!TEST_MODE)
                        ym(YANDEX_COUNTER_ID, 'reachGoal', 'ADD_TO_BASKET');
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
        }
      },
      updateQuantityInp: function (item, quantity) {



        if (quantity === undefined) {
          quantity = 1;
        } else {
          quantity = Number(quantity);
        }
        quantity = Math.ceil(parseInt(quantity) / item.step) * item.step;

        quantity = Number(quantity - this.basketCount);

        let vm = this;
        //TODO: После утвержения удалить droptransit
        if (item.storage.first == 0 && item.storage.second == 0 && false) {
          axios.post(
                  '/api/transit/add',
                  {
                    'productId': vm.productId,
                    'quantity': quantity,
                  },
                  {
                    headers: {
                      'content-type': 'application/json; charset=utf8',
                      'X-Requested-With': 'XMLHttpRequest',
                    }
                  }
          )
                  .then(function (response) {
                    if (response.status == 200) {
                      item.transit_list = quantity;
                      vm.drawNotify(item, response.data);

                      return false;
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });

          return false;
        } else if(quantity > 0) {
          axios.post(
                  '/api/cart/add/' + vm.productId,
                  {
                    'quantity': quantity,
                  },
                  {
                    headers: {
                      'content-type': 'application/json; charset=utf8',
                      'X-Requested-With': 'XMLHttpRequest',
                    }
                  }
          )
          .then(function (response) {
            if (response.status == 200) {
              let data = response.data;
              let basket = vm.$ls.get('basket');

              if (data.status) {
                let result = data.result;
                switch (data.type) {
                  case 'add':
                    let product = result.product;
                    basket.count += product.quantity;
                    basket.volume += product.dimensions.volume * result.quantity / product.packing.torg.value;
                    basket.weight += product.dimensions.weight;
                    basket.price = result.price;
                    basket.items.push(product)
                    break;
                  case 'change':
                    basket.items.forEach(function (item, index) {
                      if (item.id == result.id) {
                        basket.count += result.quantity;
                        basket.volume += item.dimensions.volume * result.quantity / item.packing.torg.value;
                        basket.weight += item.dimensions.weight;
                        item.quantity += result.quantity;
                      }
                    })
                    basket.price = result.price;
                    break;
                  case 'delete':
                    basket.items.forEach(function (item, index) {
                      if (item.id == result.id) {
                        basket.count -= item.quantity;
                        basket.volume -= item.dimensions.volume * item.quantity / item.packing.torg.value;
                        basket.weight -= item.dimensions.weight;
                        basket.items.splice(index, 1);
                      }
                    });
                    basket.price = result.price;
                    vm.basketCount = 0;
                    break;
                  default:
                    console.log('Ошибка при добавлении товара! Тип');
                }
              } else {
                console.log('Ошибка при добавлении товара! Статус');
              }

              vm.$ls.set('basket', basket);
              document.dispatchEvent(new CustomEvent("updateBasket", {detail: basket}));

              if (!TEST_MODE)
                ym(YANDEX_COUNTER_ID, 'reachGoal', 'ADD_TO_BASKET');
            }
          })
          .catch(function (error) {
                    console.log(error);
                  });
        }

      },

      addWaitingList: function(item, quantity){
        let vm = this;

        axios.post(
                '/api/transit/add',
                {
                  'productId': vm.productId,
                  'quantity': quantity,
                },
                {
                  headers: {
                    'content-type': 'application/json; charset=utf8',
                    'X-Requested-With': 'XMLHttpRequest',
                  }
                }
        )
                .then(function (response) {
                  if (response.status == 200) {
                    item.transit_list = quantity;
                    vm.drawNotify(item, response.data);

                    return false;
                  }
                })
                .catch(function (error) {
                  console.log(error);
                });
      },


      changeBasket: function (event) {
        let basket = [], vm = this;
        if ('detail' in event && event.detail)
          basket = event.detail;
        else
          basket = event;
        basket.items.forEach(function (basketItem) {
          if (vm.productId == basketItem.productId)
            vm.basketCount = basketItem.quantity;
        });
      },

      drawNotify: function (item, result) {
        let id = item.id;
        if (this.user.isAuthorized) {
          if (this.notifyIds.length > 0) {
            this.notifyIds.forEach(notifyId => {
              if (notifyId == id)
                this.$notify.close(id);
            })
          }

          let message = result.message;
          if (result.type == 'change')
            message = message + ' на ' + result.result.quantity + '. ';

          if (result.type == 'add')
            message = message + ' в количестве ' + result.result.quantity + '. ';

          this.$notify({
            id,
            group: this.groupNotify,
            title: message + 'Вы будете уведомлены по поступлению товара на склад.',
            text: item.name,
            type: '',
            duration: 4000,
            speed: 0,
            data: item
          });
          this.notifyIds.push(id);
        }
      },
    },
    components: {
      VuePopper,
    }
  }
</script>

<style scoped>
  .product__prices.not-available {
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
  }
  .product__prices.not-available .product__buy-action{
    margin-top:0px;
  }
</style>